import React from 'react';
import { ChevronLeftIcon } from 'lucide-react';
import { DmpLogo } from '../brand/DmpLogo';
import { BdFlag } from '../brand/BdFlag';
interface MobileHeaderProps {
  appName: string;
  title?: string;
  onBack?: () => void;
  right?: React.ReactNode;
}
export function MobileHeader({
  appName,
  title,
  onBack,
  right
}: MobileHeaderProps) {
  return <header className="shrink-0 bg-navy text-white" data-id="element-138" data-mp="3sfc07nc2nfbq">
      <div className="flex items-center gap-2.5 px-4 pt-3 pb-3" data-id="element-139" data-mp="t2l43879l2uf">
        {onBack ? <button onClick={onBack} className="-ml-1.5 flex h-9 w-9 items-center justify-center rounded-full hover:bg-white/10" aria-label="পেছনে যান" data-id="element-140" data-mp="p06merfc094q">
            <ChevronLeftIcon className="h-6 w-6" data-id="element-141" data-mp="jzsdl75wov5n" />
          </button> : <DmpLogo size={36} tone="light" data-id="element-142" data-mp="f20iy5dvmuxr" />}
        <div className="min-w-0 flex-1" data-id="element-143" data-mp="34rkqmrhx1ge5">
          <p className="truncate text-[15px] font-bold leading-tight" data-id="element-144" data-mp="34tfae2hgb2gn">{title ?? appName}</p>
          {title && <p className="truncate text-[11px] text-white/70" data-id="element-145" data-mp="2zr6f2zh3vobd">{appName}</p>}
          {!title && <p className="truncate text-[11px] text-white/70" data-id="element-146" data-mp="pl0dh4gxebi1">ঢাকা মেট্রোপলিটন পুলিশ</p>}
        </div>
        {right}
        <BdFlag width={24} data-id="element-147" data-mp="tl0vt075b6ud" />
      </div>
    </header>;
}